import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(() => ({
  button: {
    borderRadius: 4,
    height: 24,
    minWidth: 24,
    width: 24,
    padding: 0,
  },
}));
